function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import InputMask from 'react-input-mask';
import { body1Styles } from '../../../typography/style';
import Icon from '../../../icon';
import { deviceMediaQueries } from '../../../../theme';
import IconButton from '../../../icon-button';
import TriggerTooltip from '../../../trigger-tooltip';
import PersistentTooltip from '../../../persistent-tooltip';

var getPaddingStyles = p => {
  if (p.hasInlinePlusMinusIconButtons) {
    return '9px 70px 3px 0px';
  } else if (p.hasInlineIcon) {
    return '9px 25px 3px 0px';
  } else {
    return '9px 6px 3px 0px';
  }
};

var inputStyling = /*#__PURE__*/css(["", ";background:none;color:", ";padding:", ";display:block;border:none;border-radius:0;width:100%;text-overflow:ellipsis;", "{font-size:", "px;}", "{font-size:", "px;}", "{font-size:", "px;}", ""], body1Styles, p => p.theme.colors.gray800, p => getPaddingStyles(p), deviceMediaQueries.mobile, p => p.textSizeMap.mobile, deviceMediaQueries.tablet, p => p.textSizeMap.tablet, deviceMediaQueries.desktop, p => p.textSizeMap.desktop, p => (!p.readOnly || p.interactableReadOnly) && "\n        border-bottom: 1px solid ".concat(p.showError ? p.theme.colors.error : p.theme.colors.gray200, ";\n        &:focus {\n            outline: none;\n        }\n        &:hover {\n            border-bottom: 1px solid ").concat(p.theme.colors.primary500, ";\n        }\n        transition: 400ms ease border-bottom;\n    "));
export var StyledUnmaskedInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "style__StyledUnmaskedInput",
  componentId: "sc-1xlt4jq-0"
})(["", ";"], inputStyling);
export var StyledMaskedInput = /*#__PURE__*/styled((_ref) => {
  var {
    showError,
    isFocused,
    interactableReadOnly,
    hasInlineIcon,
    textSizeMap,
    inputRef,
    name,
    disableErrorXIcon,
    hasInlinePlusMinusIconButtons
  } = _ref,
      inputProps = _objectWithoutProperties(_ref, ["showError", "isFocused", "interactableReadOnly", "hasInlineIcon", "textSizeMap", "inputRef", "name", "disableErrorXIcon", "hasInlinePlusMinusIconButtons"]);

  return /*#__PURE__*/React.createElement(InputMask, _extends({
    name: name,
    id: name,
    inputRef: inputRef
  }, inputProps));
}).withConfig({
  displayName: "style__StyledMaskedInput",
  componentId: "sc-1xlt4jq-1"
})(["", ";"], inputStyling);
export var ErrorIcon = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "style__ErrorIcon",
  componentId: "sc-1xlt4jq-2"
})(["pointer-events:none;position:absolute;right:0;top:10px;margin:6px;visibility:visible;opacity:1;transition:100ms linear all;", ""], p => p.hide && "\n        visibility: hidden;\n        opacity: 0;\n    ");
export var InfoIconUnfocusedInputButton = /*#__PURE__*/styled(IconButton).withConfig({
  displayName: "style__InfoIconUnfocusedInputButton",
  componentId: "sc-1xlt4jq-3"
})(["transition:130ms linear opacity,130ms linear visibility;visibility:", ";opacity:", ";position:absolute;right:0;top:", ";margin:4px;"], p => p.hide ? 'hidden' : 'visible', p => p.hide ? 0 : 1, p => p.isTooltip ? 0 : '9px');
export var TriggerTooltipWrapper = /*#__PURE__*/styled(TriggerTooltip).withConfig({
  displayName: "style__TriggerTooltipWrapper",
  componentId: "sc-1xlt4jq-4"
})(["transition:130ms linear opacity,130ms linear visibility;opacity:1;position:absolute;right:0;top:9px;margin:4px;"]);
export var PersistentTooltipWrapper = /*#__PURE__*/styled(PersistentTooltip).withConfig({
  displayName: "style__PersistentTooltipWrapper",
  componentId: "sc-1xlt4jq-5"
})(["transition:130ms linear opacity,130ms linear visibility;opacity:1;position:absolute;margin:4px;"]);